import { render } from "./NavigationPanelComp.vue?vue&type=template&id=36e9fee1"
import script from "./NavigationPanelComp.vue?vue&type=script&lang=js"
export * from "./NavigationPanelComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__